
<!-- Stats Cards -->
<!-- <mat-grid-list cols="4" rowHeight="120px" gutterSize="16px">
  <mat-grid-tile *ngFor="let stat of stats">
    <mat-card [style.background-color]="stat.color" class="stat-card">
      <mat-icon>{{stat.icon}}</mat-icon>
      <div>
        <h2>{{stat.value}}</h2>
        <p>{{stat.title}}</p>
      </div>
    </mat-card>
  </mat-grid-tile>
</mat-grid-list> -->

<!-- Table Listing -->
<mat-card class="table-card">
  <!-- <mat-card-title>Recent Orders</mat-card-title>
  <mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> Order </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="amount">
      <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.amount}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table> -->
</mat-card>
